<template>
  <div>
    <vue-good-table
      :columns="columns"
      :rows="tableData"
      :sortOptions="{enabled: false}"
    >
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field === 'action'">
          <app-primary-button
            label="Activate"
            v-on:click.native="
              handleClicked('activate', props.formattedRow['id'])
            "
            v-if="props.formattedRow['enabled'] === 'No'"
            :disabled="api['TOGGLE-FEATURE'].loading"
            :loading="api['TOGGLE-FEATURE'].loading"
          ></app-primary-button>
          <app-primary-button
            label="Deactivate"
            class="btn btn-tertiary"
            v-on:click.native="
              handleClicked('deactivate', props.formattedRow['id'])
            "
            :disabled="api['TOGGLE-FEATURE'].loading"
            :loading="api['TOGGLE-FEATURE'].loading"
            v-else
          ></app-primary-button>
        </span>
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
    </vue-good-table>
  </div>
</template>
<script>
import {VueGoodTable} from 'vue-good-table';
import FeatureServiceV2 from '../../services/V2/FeatureServiceV2';
import AppPrimaryButton from '../AppComponents/Forms/AppPrimaryButton.vue';
import ApiCallMixin from '../../mixins/ApiCallMixin';

export default {
  props: ['clientId'],
  mixins: [ApiCallMixin],
  components: {
    VueGoodTable,
    AppPrimaryButton,
  },
  data() {
    return {};
  },
  methods: {
    async getFeatures() {
      try {
        await this.request(
          'GET-FEATURES',
          FeatureServiceV2.getFeatures,
          this.clientId
        );
      } catch (error) {}
    },
    async getClientFeatures() {
      try {
        await this.request(
          'GET-CLIENT-FEATURES',
          FeatureServiceV2.getClientFeatures,
          this.clientId
        );
      } catch (error) {}
    },
    async handleClicked(action, featureId) {
      await this.request(
        'TOGGLE-FEATURE',
        FeatureServiceV2.toggleFeature,
        featureId,
        this.clientId,
        action
      );
      this.getClientFeatures();
    },
  },
  computed: {
    clientFeatures() {
      if (!this.api['GET-CLIENT-FEATURES']) return [];
      if (!this.api['GET-CLIENT-FEATURES'].response) return [];
      if (!this.api['GET-CLIENT-FEATURES'].response.data) return [];
      if (!this.api['GET-CLIENT-FEATURES'].response.data.data) return [];

      return this.api['GET-CLIENT-FEATURES'].response.data.data;
    },
    features() {
      if (!this.api['GET-FEATURES']) return [];
      if (!this.api['GET-FEATURES'].response) return [];
      if (!this.api['GET-FEATURES'].response.data) return [];
      if (!this.api['GET-FEATURES'].response.data.data) return [];

      return this.api['GET-FEATURES'].response.data.data;
    },
    tableData() {
      const data = this.features.map((feature) => {
        const enabled = this.clientFeatures[feature.key] === true;

        return {
          ...feature,
          enabled: enabled ? 'Yes' : 'No',
        };
      });

      return data;
    },
    columns() {
      return [
        {
          label: 'ID',
          field: 'id',
          hidden: true,
        },
        {
          label: 'Feature',
          field: 'name',
        },
        {
          label: 'Description',
          field: 'description',
        },
        {
          label: 'Enabled',
          field: 'enabled',
        },
        {
          label: 'Action',
          field: 'action',
        },
      ];
    },
  },
  mounted() {
    this.registerApis([
      'GET-FEATURES',
      'GET-CLIENT-FEATURES',
      'TOGGLE-FEATURE',
    ]);
    this.getFeatures();
    this.getClientFeatures();
  },
};
</script>
